import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdressInputComponentTexte } from '@ps20-frontend/frontend-models';
import { ControlContainer, NgForm, FormsModule } from '@angular/forms';
import { NxFormfieldComponent, NxFormfieldErrorDirective } from '@allianz/ng-aquila/formfield';
import { NxInputDirective } from '@allianz/ng-aquila/input';
import { NxErrorComponent } from '@allianz/ng-aquila/base';
import { NxDropdownComponent, NxDropdownItemComponent } from '@allianz/ng-aquila/dropdown';
import { RegexpPipe } from '@ps20-frontend/regexp-service';
import { searchFromBeginningFn } from './searchFromBeginning';
import { AdressInputType } from './adress-input.component.model';

@Component({
  selector: 'ps20-frontend-adress-input-component',
  templateUrl: './adress-input.component.html',
  styleUrls: ['./adress-input.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [
    NxFormfieldComponent,
    NxInputDirective,
    FormsModule,
    NxErrorComponent,
    NxFormfieldErrorDirective,
    NxDropdownComponent,
    NxDropdownItemComponent,
    RegexpPipe,
  ],
})
export class AdressInputComponent {
  @Input() aktuelleAuswahl: string;
  @Input() auswahlListe: Array<string>;
  @Input() texte: AdressInputComponentTexte = {
    label: 'defaultLabel',
    required: 'defaultRequired',
    pattern: 'defaultPattern',
    dropdownPlaceholder: 'defaultPlaceholder',
    ariaLabel: 'defaultAriaLabel',
  };
  @Input() name: string;
  @Input() disabled = false;
  @Output() auswahlChanged = new EventEmitter<string>();
  adressInputType = AdressInputType;
  searchFromBeginning = searchFromBeginningFn;

  getInputType(): AdressInputType {
    if (this.auswahlListe == null) {
      return AdressInputType.Input;
    }

    if (this.auswahlListe && this.auswahlListe.length <= 1) {
      return AdressInputType.InputReadOnly;
    }
    return AdressInputType.Dropdown;
  }
}
